import React, { useState } from 'react';
import { 
  Zap,
  Globe,
  Key,
  Shield,
  Activity,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Clock,
  Eye,
  Trash2,
  Download,
  Plus,
  Edit,
  Save,
  X,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Building,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  User,
  Users,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Globe as GlobeIcon,
  Users2,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart,
  AreaChart,
  TrendingUp,
  TrendingDown,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon2,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon2,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon3,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon2,
  CheckCircle as CheckCircleIcon2,
  XCircle as XCircleIcon2,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon2,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const APIManagement = () => {
  const [activeTab, setActiveTab] = useState('endpoints');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for API endpoints
  const [apiEndpoints, setApiEndpoints] = useState([
    {
      id: 'API-001',
      endpointName: 'Contract Management API',
      endpointUrl: '/api/v1/contracts',
      method: 'GET',
      status: 'Active',
      version: 'v1.2.0',
      lastUpdated: '2024-02-15',
      responseTime: '45ms',
      successRate: 99.8,
      totalCalls: 125000,
      rateLimit: '1000/hour',
      authentication: 'Bearer Token',
      isActive: true,
      tags: ['contracts', 'rest', 'v1'],
      isBookmarked: true,
      isStarred: true,
      viewCount: 234,
      downloadCount: 15,
      aiInsights: ['High performance endpoint', 'Stable response times', 'Good success rate'],
      keyMetrics: {
        averageResponseTime: '45ms',
        errorRate: '0.2%',
        throughput: '125 req/min',
        uptime: '99.9%'
      },
      alerts: [],
      performanceScore: 96.2
    },
    {
      id: 'API-002',
      endpointName: 'Asset Management API',
      endpointUrl: '/api/v1/assets',
      method: 'POST',
      status: 'Active',
      version: 'v1.1.0',
      lastUpdated: '2024-02-14',
      responseTime: '120ms',
      successRate: 98.5,
      totalCalls: 89000,
      rateLimit: '500/hour',
      authentication: 'API Key',
      isActive: true,
      tags: ['assets', 'rest', 'v1'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 189,
      downloadCount: 12,
      aiInsights: ['Good performance', 'Minor response time variations', 'Reliable endpoint'],
      keyMetrics: {
        averageResponseTime: '120ms',
        errorRate: '1.5%',
        throughput: '89 req/min',
        uptime: '99.7%'
      },
      alerts: ['Response time above threshold'],
      performanceScore: 87.6
    },
    {
      id: 'API-003',
      endpointName: 'User Authentication API',
      endpointUrl: '/api/v2/auth',
      method: 'POST',
      status: 'Deprecated',
      version: 'v2.0.0',
      lastUpdated: '2024-01-15',
      responseTime: '200ms',
      successRate: 95.2,
      totalCalls: 45000,
      rateLimit: '200/hour',
      authentication: 'OAuth 2.0',
      isActive: false,
      tags: ['auth', 'oauth', 'deprecated'],
      isBookmarked: false,
      isStarred: false,
      viewCount: 67,
      downloadCount: 5,
      aiInsights: ['Deprecated endpoint', 'Consider migration to v3', 'Still functional'],
      keyMetrics: {
        averageResponseTime: '200ms',
        errorRate: '4.8%',
        throughput: '45 req/min',
        uptime: '98.5%'
      },
      alerts: ['Endpoint deprecated', 'Migration recommended'],
      performanceScore: 65.8
    }
  ]);

  // Mock data for API keys
  const [apiKeys, setApiKeys] = useState([
    {
      id: 'KEY-001',
      keyName: 'Contract Management Key',
      keyValue: 'cm_****_****_****_****',
      status: 'Active',
      permissions: ['read', 'write'],
      rateLimit: '1000/hour',
      expiresAt: '2024-12-31',
      lastUsed: '2024-02-15 14:30:00',
      usageCount: 1250,
      createdBy: 'API Admin',
      isActive: true,
      tags: ['contracts', 'production', 'high-usage'],
      isBookmarked: true,
      isStarred: true,
      viewCount: 156,
      downloadCount: 8,
      aiInsights: ['High usage key', 'Good security practices', 'Regular usage pattern'],
      keyMetrics: {
        dailyUsage: '1250',
        averageUsage: '52/hour',
        errorRate: '0.1%',
        lastError: 'None'
      },
      alerts: [],
      performanceScore: 94.2
    },
    {
      id: 'KEY-002',
      keyName: 'Asset Management Key',
      keyValue: 'am_****_****_****_****',
      status: 'Active',
      permissions: ['read'],
      rateLimit: '500/hour',
      expiresAt: '2024-08-15',
      lastUsed: '2024-02-14 16:45:00',
      usageCount: 890,
      createdBy: 'API Admin',
      isActive: true,
      tags: ['assets', 'read-only', 'medium-usage'],
      isBookmarked: false,
      isStarred: false,
      viewCount: 89,
      downloadCount: 5,
      aiInsights: ['Read-only access', 'Moderate usage', 'Good security'],
      keyMetrics: {
        dailyUsage: '890',
        averageUsage: '37/hour',
        errorRate: '0.5%',
        lastError: 'Rate limit exceeded'
      },
      alerts: ['Rate limit exceeded once'],
      performanceScore: 82.6
    }
  ]);

  // Calculate statistics
  const stats = {
    totalEndpoints: apiEndpoints.length,
    activeEndpoints: apiEndpoints.filter(e => e.status === 'Active').length,
    deprecatedEndpoints: apiEndpoints.filter(e => e.status === 'Deprecated').length,
    totalApiCalls: apiEndpoints.reduce((sum, endpoint) => sum + endpoint.totalCalls, 0),
    averageResponseTime: apiEndpoints.reduce((sum, endpoint) => {
      const responseTime = parseFloat(endpoint.responseTime.replace('ms', ''));
      return sum + responseTime;
    }, 0) / apiEndpoints.length,
    totalApiKeys: apiKeys.length,
    activeApiKeys: apiKeys.filter(k => k.status === 'Active').length,
    totalKeyUsage: apiKeys.reduce((sum, key) => sum + key.usageCount, 0),
    averageSuccessRate: apiEndpoints.reduce((sum, endpoint) => sum + endpoint.successRate, 0) / apiEndpoints.length
  };

  const tabs = [
    { id: 'endpoints', label: 'API Endpoints' },
    { id: 'api-keys', label: 'API Keys' },
    { id: 'documentation', label: 'API Documentation' },
    { id: 'monitoring', label: 'API Monitoring' }
  ];

  // Define columns for API Endpoints DataTable
  const apiEndpointsColumns = [
    {
      key: 'endpointName',
      label: 'Endpoint Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.endpointUrl} • v{row.version}
          </div>
        </div>
      )
    },
    {
      key: 'method',
      label: 'Method',
      width: '80px',
      render: (method) => {
        const methodConfig = {
          'GET': { color: '#10b981', bg: '#d1fae5' },
          'POST': { color: '#3b82f6', bg: '#dbeafe' },
          'PUT': { color: '#f59e0b', bg: '#fef3c7' },
          'DELETE': { color: '#ef4444', bg: '#fee2e2' },
          'PATCH': { color: '#8b5cf6', bg: '#ede9fe' }
        };
        const config = methodConfig[method] || methodConfig['GET'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {method}
          </span>
        );
      }
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5' },
          'Deprecated': { color: '#f59e0b', bg: '#fef3c7' },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6' },
          'Error': { color: '#ef4444', bg: '#fee2e2' }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {status}
          </span>
        );
      }
    },
    {
      key: 'responseTime',
      label: 'Response Time',
      width: '120px',
      render: (time) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{time}</span>
      )
    },
    {
      key: 'successRate',
      label: 'Success Rate',
      width: '120px',
      render: (rate) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${Math.min(rate, 100)}%`,
              height: '100%',
              backgroundColor: rate >= 95 ? '#10b981' : rate >= 90 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: rate >= 95 ? '#10b981' : rate >= 90 ? '#f59e0b' : '#ef4444' 
          }}>
            {rate.toFixed(1)}%
          </span>
        </div>
      )
    },
    {
      key: 'totalCalls',
      label: 'Total Calls',
      width: '120px',
      render: (calls) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>
          {calls.toLocaleString()}
        </span>
      )
    },
    {
      key: 'rateLimit',
      label: 'Rate Limit',
      width: '100px',
      render: (limit) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{limit}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Endpoint"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Endpoint"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for API Keys DataTable
  const apiKeysColumns = [
    {
      key: 'keyName',
      label: 'API Key Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.keyValue}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5' },
          'Inactive': { color: '#6b7280', bg: '#f3f4f6' },
          'Expired': { color: '#ef4444', bg: '#fee2e2' },
          'Suspended': { color: '#f59e0b', bg: '#fef3c7' }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {status}
          </span>
        );
      }
    },
    {
      key: 'permissions',
      label: 'Permissions',
      width: '120px',
      render: (permissions) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>
          {Array.isArray(permissions) ? permissions.join(', ') : permissions}
        </span>
      )
    },
    {
      key: 'rateLimit',
      label: 'Rate Limit',
      width: '100px',
      render: (limit) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{limit}</span>
      )
    },
    {
      key: 'usageCount',
      label: 'Usage Count',
      width: '120px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>
          {count.toLocaleString()}
        </span>
      )
    },
    {
      key: 'expiresAt',
      label: 'Expires At',
      width: '120px',
      render: (date) => {
        const expiryDate = new Date(date);
        const today = new Date();
        const daysUntilExpiry = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
        const isExpiringSoon = daysUntilExpiry <= 30;
        
        return (
          <span style={{ 
            fontWeight: '500', 
            color: isExpiringSoon ? '#ef4444' : '#1f2937' 
          }}>
            {new Date(date).toLocaleDateString()}
          </span>
        );
      }
    },
    {
      key: 'lastUsed',
      label: 'Last Used',
      width: '140px',
      render: (time) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{time}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Key"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Key"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.endpointName || item.keyName);
  };

  const handleExport = (item) => {
    setSelectedItem(item);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'endpoints') {
        setApiEndpoints(prev => prev.filter(endpoint => endpoint.id !== selectedItem.id));
      } else {
        setApiKeys(prev => prev.filter(key => key.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          API Management
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Manage API endpoints, keys, and monitor API performance and usage
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'endpoints' && <Zap size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'api-keys' && <Key size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'documentation' && <FileTextIcon size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'monitoring' && <Activity size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>API Endpoints</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalEndpoints}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeEndpoints} active, {stats.deprecatedEndpoints} deprecated
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <Zap size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total API Calls</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {(stats.totalApiCalls / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              API requests processed
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <Activity size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>API Keys</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalApiKeys}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeApiKeys} active keys
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <Key size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Avg Response Time</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageResponseTime.toFixed(0)}ms
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.averageSuccessRate.toFixed(1)}% success rate
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ef444420',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ef4444'
          }}>
            <Clock size={20} />
          </div>
        </div>
      </div>

      {/* API Endpoints Tab */}
      {activeTab === 'endpoints' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={apiEndpoints}
              columns={apiEndpointsColumns}
              title={`API Endpoints (${apiEndpoints.length} endpoints)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* API Keys Tab */}
      {activeTab === 'api-keys' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={apiKeys}
              columns={apiKeysColumns}
              title={`API Keys (${apiKeys.length} keys)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'documentation' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          API Documentation Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'monitoring' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          API Monitoring Dashboard Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Item"
        message={`Are you sure you want to delete "${selectedItem?.endpointName || selectedItem?.keyName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export API report for "${selectedItem?.endpointName || selectedItem?.keyName}"? This will generate a comprehensive report with API details and usage statistics.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default APIManagement;
